import { useEffect, useState } from "react";
import { useTolgee } from "@tolgee/react";
import { Locale } from "date-fns";
import { enGB } from "date-fns/locale";
import { ENGLISH_LANG_CODE } from "@evennt-tech/api-v2-core";
import loadDateFnsLocale from "tools/date/loadDateFnsLocale";

const useDateFnsLocale = (): Locale => {
  const tolgee = useTolgee(["language"]);
  const code = tolgee.getLanguage() ?? ENGLISH_LANG_CODE;
  const [locale, setLocale] = useState<Locale>(enGB);

  useEffect(() => {
    let active = true;
    loadDateFnsLocale(code).then((resolved) => {
      if (active) setLocale(resolved);
    });

    return () => {
      active = false;
    };
  }, [code]);

  return locale;
};

export default useDateFnsLocale;
